// extracted by mini-css-extract-plugin
export default {"root":"VTab_root__i9vQw","active":"VTab_active__y9geP","drag-handle":"VTab_drag-handle__Y+2IW","hide":"VTab_hide__E0LtV","text":"VTab_text__5zYLC"};